import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoginForm from '../../components/auth/LoginForm';
import SignupForm from '../../components/auth/SignupForm';

const AuthPage = () => {
  const { user, loading } = useAuth()
  const [authMode, setAuthMode] = useState('login')

  // Redirect if already authenticated - now redirects to QR generator
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }

  if (user) {
    return <Navigate to="/" replace />
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <div className="mx-auto h-12 w-12 bg-blue-600 rounded-lg flex items-center justify-center mb-6">
            <svg className="h-8 w-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 16h4m-4-4h4m-4-4h4m-4-4h2a2 2 0 012 2v4m0 0a2 2 0 01-2 2h-2m0 0h-4m0 0a2 2 0 01-2-2V7a2 2 0 012-2h2m0 0h4" />
            </svg>
          </div>
          <h2 className="text-3xl font-extrabold text-gray-900">
            QR Code Generator
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Create, manage, and track QR codes with analytics
          </p>
        </div>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          {authMode === 'login' ? (
            <LoginForm onSwitchToSignup={() => setAuthMode('signup')} />
          ) : (
            <SignupForm onSwitchToLogin={() => setAuthMode('login')} />
          )}
        </div>
        
        <div className="mt-6 text-center text-sm text-gray-500">
          <p>QR Analytics Dashboard - Secure Authentication</p>
        </div>
      </div>
    </div>
  );
};

export default AuthPage;